import { useEffect, useState } from "react";
import { API, type SAVSummary } from "../api";
import { Chat } from "./Chat";

export function SAVDetail({ savId, onBack }: { savId: string; onBack: () => void }) {
  const [sav, setSav] = useState<SAVSummary | null>(null);

  async function refresh() {
    try { setSav(await API.getSAV(savId)); } catch { /* ignore */ }
  }

  useEffect(() => { refresh(); }, [savId]);

  if (!sav) {
    return (
      <div className="xs-main">
        <div className="xs-muted" style={{ textAlign: "center", padding: 32 }}>
          Chargement…
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="xs-chat-header">
        <button className="xs-chat-back" onClick={onBack} aria-label="Retour">←</button>
        <div className="xs-chat-title">
          <div className="xs-chat-ref">{sav.reference}</div>
          <div className="xs-chat-product">{sav.product_name || "Produit"}</div>
        </div>
      </div>
      <Chat savId={sav.id} onSAVUpdated={refresh} />
    </>
  );
}
